import React, { Component } from "react";
import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Auth from "./pages/Auth";
import MyInterviews from "./pages/MyInterviews";
import EditPersonalInfo from "./pages/EditPersonalInfo";
import InductionManagement from "./pages/InductionManagement";
import PositionInfo from "./pages/PositionInfo";
import AppointmentPosition from "./pages/AppointmentPosition";
import EnterpriseInfo from "./pages/EnterpriseInfo";
import ScanQRCode from "./pages/ScanQRCode";
import StartTest from "./pages/StartTest";
import AnswerQuestions from "./pages/AnswerQuestions";
import TestResult from "./pages/TestResult";
import ConfirmSignin from "./pages/ConfirmSignin";
import InterviewDetail from "./pages/InterviewDetail";
import InviteInduction from "./pages/InviteInduction";
import BindServiceCorp from "./pages/BindServiceCorp";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Enquiry from "./pages/Enquiry";
import SunmitEnterMsg from "./pages/SunmitEnterMsg";
import InvitationPage from "./pages/InvitationPage";
import SubmitOk from "./pages/SubmitOk";
import RecommendPolicy from "./pages/RecommendPolicy";
import IDCardinfo from "./pages/IDCardinfo";
import InterviewDetailNew from "./pages/InterviewDetailNew";
import VirusQuestions from "./pages/VirusQuestions";
import "./app.config";

class App extends Component {
  componentDidMount = async () => {
    if (!window.wx_js_url) {
      window.wx_js_url = window.location.href;
    }
  };

  render() {
    return (
      <div className="App" style={{ width: "100%", height: "100vh" }}>
        <Router>
          <Switch>
            {/* <Route exact path="/" component={Auth} /> */}
            {/*登录*/}
            <Route path="/login" component={Login} />
            {/*注册*/}
            <Route path="/register" component={Register} />
            {/*快速求职*/}
            <Route path="/" component={Home} />
            <Route path="/invite_induction" component={InviteInduction} />
            {/* <Route path="/query" component={Query} />
            <Route path="/select" component={Select} />
            <Route path="/fill-info" component={Fillinfo} /> */}
            {/*个人中心*/}
            <Route path="/personal_center" component={Home} />
            {/*我的面试*/}
            <Route path="/interviews" component={MyInterviews} />
            {/*问询*/}
            {/* <Route path="/messages" component={MyMessages} /> */}
            {/*完善个人信息*/}
            <Route path="/editinfo" component={EditPersonalInfo} />
            {/*职位详情*/}
            <Route path="/position_info/:id" component={PositionInfo} />
            <Route
              path="/appointment_position/:id"
              component={AppointmentPosition}
            />
            {/*入职管理*/}
            <Route
              path="/induction_management"
              component={InductionManagement}
            />
            {/*企业信息*/}
            <Route path="/enterprise_info" component={EnterpriseInfo} />
            {/*签到*/}
            <Route path="/scan_qrcode" component={ScanQRCode} />
            {/* 开始考试 */}
            <Route path="/start_test" component={StartTest} />
            {/* 答题 */}
            <Route path="/answer_questions/:id" component={AnswerQuestions} />
            {/* 考试结果 */}
            <Route path="/test_result" component={TestResult} />
            {/* 签到确认 */}
            <Route path="/confirm_signin/:id" component={ConfirmSignin} />
            {/* 面试详情 */}
            <Route path="/interview_detail/:id" component={InterviewDetail} />
            {/* 问询 */}
            <Route path="/enquiry" component={Enquiry} />
            {/* 提交入职信息 */}
            <Route path="/sunmitEnterMsg" component={SunmitEnterMsg} />
            {/* 邀请入职 */}
            <Route path="/invitationPage" component={InvitationPage} />
            <Route path="/recommend-policy" component={RecommendPolicy} />
            <Route path="/bind-service-corp/:id" component={BindServiceCorp} />
            {/* 提交成功 */}
            <Route path="/submitOk" component={SubmitOk} />
            <Route path="/enquiry" component={Enquiry} />
            <Route path="/idcardinfo" component={IDCardinfo} />
            <Route path="/virus-questions/:id" component={VirusQuestions} />
            <Route
              path="/interview-detail-new/:id"
              component={InterviewDetailNew}
            />

            <Route render={() => <div>404</div>} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
